import React from 'react';
import { toast } from 'react-toastify';
import { SearchActivityItem } from 'v2/common/DRM/ActivityTab/ActivityItems/SearchActivityItem';
import InfiniteScrollV2 from 'v2/common/InfiniteScrollV2/InfiniteScrollV2';
import { useIsReviewerUser } from 'v2/hooks';
import { SearchEntity } from 'v2/models';
import {
  useDeleteActivity,
  useLinkCreatedInfiniteActivities,
} from 'v2/queries';

type LinkedEntitiesListProps = {
  search: SearchEntity;
};

export function LinkedEntitiesList({ search }: LinkedEntitiesListProps) {
  const { mutate: deleteActivity } = useDeleteActivity();

  const {
    data: infiniteActivities,
    fetchNextPage: fetchNextActivitiesPage,
    hasNextPage: hasNextActivitiesPage,
  } = useLinkCreatedInfiniteActivities({ searchID: search.id });

  const isReviewerUser = useIsReviewerUser();
  const linkCreatedActivities = infiniteActivities?.pages.flatMap(
    (page) => page.results
  );

  const handleDeleteLink = (activityID: number) => {
    deleteActivity(activityID, {
      onError: () => {
        toast.error('Failed to delete link.');
      },
      onSuccess: async () => {
        toast.success('Link deleted successfully.');
      },
    });
  };

  return (
    <div>
      {linkCreatedActivities?.map((activity) => (
        <SearchActivityItem
          key={activity.id}
          activity={activity}
          onRemove={
            isReviewerUser ? () => handleDeleteLink(activity.id) : undefined
          }
          search={search}
        />
      ))}

      <InfiniteScrollV2
        fetchNextPage={fetchNextActivitiesPage}
        hasNextPage={hasNextActivitiesPage}
      />
    </div>
  );
}
